export default __webpack_public_path__ + "static/malakoff_mederic-e280e287ff948e2dfa5420c3e67c8a0b.png";